import type { ApiNode } from '@goalbuddy/client';

/** A warm, stable palette. Each top-level area keeps its color across the whole UI. */
export const AREA_COLORS = [
  '#e8590c',
  '#2f9e44',
  '#1c7ed6',
  '#9c36b5',
  '#d6336c',
  '#0c8599',
  '#f08c00',
  '#5f3dc4',
];

export function areaColor(structure: ApiNode[] | undefined, id: number | null | undefined): string | null {
  if (!structure || id == null) return null;
  const byId = new Map(structure.map((n) => [n.id, n]));
  let cur = byId.get(id);
  for (let i = 0; cur && i < 64; i++) {
    if (cur.parent_id === null || cur.type === 'area') return AREA_COLORS[cur.id % AREA_COLORS.length]!;
    cur = byId.get(cur.parent_id);
  }
  return null;
}
